// React import
import React from 'react';
// Components imports
import NavBarButton from "../NavBarButton";
// Styles imports
import './Navbar.css';
import '../../util.css'
// Consts imports
import {
    PAGE_HOME,
    PAGE_CHECK_WALLET,
    PAGE_TOKEN_ANALYZER,
    PAGE_UPGRADE
} from "../../consts/consts";

class Navbar extends React.Component {
    render () {
        return(
            <div className={'navbar noselect'}>
                <NavBarButton buttonName = {PAGE_HOME} />
                <NavBarButton buttonName = {PAGE_CHECK_WALLET} />
                <NavBarButton buttonName = {PAGE_TOKEN_ANALYZER} />
                <NavBarButton buttonName = {PAGE_UPGRADE} />
            </div>);
    }
}

export default Navbar;
